import Corporation           from "../../../domain/corporation/Corporation";
import CorporationApplicant  from "../../../domain/corporation/CorporationApplicant";
import CorporationId         from "../../../domain/corporation/CorporationId";
import CorporationName       from "../../../domain/corporation/CorporationName";
import CorporationNameKana   from "../../../domain/corporation/CorporationNameKana";
import CorporationRepository from "../../../domain/corporation/CorporationRepository";
import Address               from "../../../domain/fundamentals/address/Address";
import Building              from "../../../domain/fundamentals/address/Building";
import City                  from "../../../domain/fundamentals/address/City";
import PostalCode            from "../../../domain/fundamentals/address/PostalCode";
import Prefecture            from "../../../domain/fundamentals/address/Prefecture";
import Street                from "../../../domain/fundamentals/address/Street";
import Email                 from "../../../domain/fundamentals/email/Email";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FirstName             from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana         from "../../../domain/fundamentals/name/FirstNameKana";
import LastName              from "../../../domain/fundamentals/name/LastName";
import LastNameKana          from "../../../domain/fundamentals/name/LastNameKana";
import Name                  from "../../../domain/fundamentals/name/Name";
import Phone                 from "../../../domain/fundamentals/phone/Phone";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import CorporationDataSource from "../../../infrastructure/datasource/corporation/CorporationDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";

class GetCorporation {
  constructor(
    private readonly dispatch,
    private readonly corporationRepository: CorporationRepository = new CorporationDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch)
  ) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const response = await this.corporationRepository.find();
      this.corporationRepository.setCorporation(
        new Corporation(
          new CorporationId(response.data.id),
          new CorporationName(response.data.name),
          new CorporationNameKana(response.data.name_kana),
          new Phone(response.data.phone_number),
          new CorporationApplicant(
            new Name(
              new LastName(response.data.applicant.last_name),
              new FirstName(response.data.applicant.first_name),
              new LastNameKana(response.data.applicant.last_name_kana),
              new FirstNameKana(response.data.applicant.first_name_kana)
            ),
            new Email(response.data.applicant.email_address)
          ),
          new Address(
            new PostalCode(response.data.address.postal_code),
            new Prefecture(response.data.address.prefecture),
            new City(response.data.address.city),
            new Street(response.data.address.street),
            new Building(response.data.address.building)
          )
        )
      );
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetCorporation;
